const dayMilliseconds = 60 * 60 * 24 * 1000;

interface ToRelativeDateOptions {
  date: number;
  locale?: string;
}

export const toRelativeDate = ({ date, locale = "en" }: ToRelativeDateOptions) => {
  const formatter = new Intl.RelativeTimeFormat(locale, {
    numeric: "auto",
  });

  const daysDifference = Math.round((date - new Date().getTime()) / dayMilliseconds);

  return formatter.format(daysDifference, "day");
};
